/**
 * Extract plain text from HTML string using regex
 * No dependencies required, works in any JavaScript environment
 * @param {string} html - HTML string
 * @returns {string} - Plain text content
 */
const extractPlainText = (html) => {
  // Handle empty or undefined input
  if (!html) return "";

  return (
    html
      // Replace HTML tags with spaces
      .replace(/<[^>]*>/g, " ")
      // Replace common HTML entities
      .replace(/&nbsp;/g, " ")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      // Replace other HTML entities
      .replace(/&[^;]+;/g, " ")
      // Normalize spaces (replace multiple spaces with a single space)
      .replace(/\s+/g, " ")
      // Trim leading and trailing spaces
      .trim()
  );
};

// Export for CommonJS environments
if (typeof module !== "undefined" && module.exports) {
  module.exports = { extractPlainText };
}

// Export for ES modules
export { extractPlainText };
